import { useNavigate } from 'react-router-dom';
import { Modal, Loading, ErrorState } from '@/components';
import { useFiscalYear } from '@/fiscal-year/FiscalYearProvider';
import { todayISO, toWareki, weekdayJa } from '@/lib/wareki';
import { useNoticeVesselContext } from '../api';

function datesBetween(from: string, to: string): string[] {
  const out: string[] = [];
  const d = new Date(`${from}T00:00:00Z`);
  const end = new Date(`${to}T00:00:00Z`);
  while (d <= end && out.length < 60) {
    out.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}

/** 定時連絡登録：出港日〜入港日の中から発信日を選ぶ（登録済みの日は編集へ） */
export function FixedReportDatePicker({ rowId, onClose }: { rowId: number | null; onClose: () => void }) {
  const { yearPath } = useFiscalYear();
  const navigate = useNavigate();
  const { data, isPending, error } = useNoticeVesselContext(rowId);
  const today = todayISO();
  return (
    <Modal open={rowId != null} onClose={onClose} title="定時連絡の発信日を選択" size="lg">
      {isPending ? (
        <Loading block />
      ) : error ? (
        <ErrorState error={error} />
      ) : data ? (
        <>
          <p className="bs-panel__desc" style={{ marginTop: 0 }}>
            {data.vessel.name}（{data.businessOperator.name}）　出港 {toWareki(data.period.from)} ～ 入港 {toWareki(data.period.to)}
          </p>
          <div className="bs-date-pick">
            {datesBetween(data.period.from, data.period.to).map((d) => {
              const existing = data.existingFixedReports.find((f) => f.reportDate === d);
              return (
                <button
                  key={d}
                  type="button"
                  className={d === today ? 'is-today' : undefined}
                  onClick={() =>
                    navigate(existing ? yearPath(`fixed-reports/${existing.id}/edit`) : yearPath(`fixed-reports/new?noticeVesselId=${rowId}&date=${d}`))
                  }
                >
                  <span className="bs-date-pick__date">
                    {d.replaceAll('-', '/')}（{weekdayJa(d)}）
                  </span>
                  <span className={existing ? 'bs-date-pick__state is-done' : 'bs-date-pick__state'}>{existing ? '登録済（編集）' : d === today ? '今日・未登録' : '未登録'}</span>
                </button>
              );
            })}
          </div>
        </>
      ) : null}
    </Modal>
  );
}
